import Vue from 'vue'
import App from './App.vue'
import store from './store'
import lang from './lang'

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App),
  i18n: lang
}).$mount('#app')
